import { NgModule } from '@angular/core';
import { ContactInfoFormModule } from 'app/components/contact-info/contact-info.module';
import { SharedModule } from 'app/shared/shared.module';
import { QuickCreatePropertyComponent } from './quick-create-property.component';

@NgModule({
    declarations: [
        QuickCreatePropertyComponent,
    ],
    imports: [
        SharedModule,
        ContactInfoFormModule
    ],
    exports: [
        QuickCreatePropertyComponent
    ]
})
export class QuickCreatePropertyModule { }
